export default {
  title: 'HubRise',
  setup: {
    description: 'Deel gegevens met andere applicaties.',
  },
  form: {
    is_menus_sync_enabled: 'Menu synchroniseren',
    is_inventory_sync_enabled: 'Voorraad synchroniseren',
    is_opening_hours_sync_enabled: 'Openingstijden synchroniseren',
    is_order_acceptance_mode_sync_enabled: 'Druk / gepauzeerde status synchroniseren',
    variant_ref: 'Menuvariant',
    variant_ref_default: 'Standaard',
  },
  tabs: {
    settings: 'Instellingen',
    service_types: 'Servicetypen',
    payments: 'Betalingen',
    charges: 'Kosten',
    deals: 'Deals',
    discounts: 'Kortingen',
    customers: 'Klanten',
  },
  customers: {
    description:
      'Wis de gegevens van één klant aan de HubRise-zijde, bijvoorbeeld na een verzoek tot gegevensverwijdering. Dit kan niet ongedaan worden gemaakt.',
    customer: 'Klant',
    placeholder: 'Zoeken op naam, e-mail of telefoon…',
  },
  mapping: {
    description:
      'Koppel elke {{provider}}-entiteit aan de bijbehorende HubRise-waarde en naam. Laat een rij leeg om de {{provider}}-standaarden te gebruiken.',
    entity: '{{provider}}',
    value: 'HubRise-waarde',
    name: 'HubRise-naam',
  },
  connecting: {
    title: 'HubRise-verbinding afronden…',
    description: 'Dit duurt een paar seconden. Houd deze pagina open.',
    error_title: 'De HubRise-verbinding duurt langer dan verwacht',
    error_description:
      'HubRise is geautoriseerd, maar de verbinding is nog niet bevestigd. Controleer het over een moment opnieuw — als het blijft mislukken, start de verbinding opnieuw.',
  },
  buttons: {
    connect: 'Verbinden met HubRise',
    check_again: 'Opnieuw controleren',
    disconnect: 'Verbreken',
    go_to_hubrise: 'Naar HubRise gaan',
    pull_menus: 'Menu ophalen',
    pull_inventory: 'Voorraad ophalen',
    save: 'Opslaan',
    delete_customer: 'Klant verwijderen',
  },
  toasts: {
    connected: 'HubRise is verbonden',
    connect_cancelled: 'HubRise-verbinding is geannuleerd',
    connect_error: 'HubRise-verbinding starten mislukt',
    connect_timeout: 'De HubRise-verbinding kon nog niet worden bevestigd',
    local_changes_replaced:
      'De HubRise-instellingen zijn elders bijgewerkt — uw niet-opgeslagen wijzigingen zijn vervangen',
    disconnect_success: 'HubRise is losgekoppeld',
    disconnect_error: 'HubRise loskoppelen mislukt',
    pull_menus_success: 'Menusynchronisatie is gestart',
    pull_menus_error: 'Menu ophalen mislukt',
    pull_inventory_success: 'Voorraadsynchronisatie is gestart',
    pull_inventory_error: 'Voorraad ophalen mislukt',
    save_success: 'HubRise-instellingen zijn opgeslagen',
    save_error: 'HubRise-instellingen opslaan mislukt',
    load_customers_error: 'Klanten laden mislukt',
    delete_customer_success: 'Het verwijderen van de klantgegevens is aangevraagd',
    delete_customer_error: 'Klantgegevens verwijderen mislukt',
  },
  delete_customer_confirm: {
    title: 'Deze klant verwijderen uit HubRise?',
    description: 'De gegevens van de klant worden gewist aan de HubRise-zijde. Dit kan niet ongedaan worden gemaakt.',
    ok: 'Verwijderen',
    cancel: 'Annuleren',
  },
  disconnect_confirm: {
    title: 'HubRise verbreken?',
    description: "Dit stopt de synchronisatie van menu's, voorraad en bestellingen met HubRise.",
    ok: 'Verbreken',
    cancel: 'Annuleren',
  },
  connected: {
    title: 'Verbonden met HubRise',
    description: 'Uw HubRise-account is succesvol gekoppeld.',
    account: 'Account',
    location: 'Locatie',
    catalog: 'Catalogus',
    customer_list: 'Klantenlijst',
  },
};
